export const YANO_VIDEO_EFFECTS_VERSION = 1

export const VIDEO_GRADES = [
  { id: "off", label: "OFF", filter: "saturate(1) contrast(1) brightness(1) hue-rotate(0deg)" },
  { id: "pop", label: "POP", filter: "saturate(1.14) contrast(1.06) brightness(1.05) hue-rotate(-6deg)" },
  { id: "warm", label: "WARM", filter: "saturate(1.08) contrast(1.05) brightness(1.03) hue-rotate(10deg)" },
  { id: "cool", label: "COOL", filter: "saturate(1.08) contrast(1.06) brightness(1.03) hue-rotate(-18deg)" },
  { id: "bw", label: "B&W", filter: "grayscale(1) contrast(1.08) brightness(1.05)" }
]

export const SOFT_FILTER = "blur(0.7px) contrast(1.12) saturate(1.05) brightness(1.03)"

export function normalizeVideoEffects(raw = {}) {
  const allowedGrades = new Set(VIDEO_GRADES.map((g) => g.id))
  const grade = typeof raw.grade === "string" && allowedGrades.has(raw.grade) ? raw.grade : "off"
  const soft = Boolean(raw.soft)
  const vignette = Boolean(raw.vignette)
  const faceBlur = Boolean(raw.faceBlur)
  const faceBlurPxRaw = Number(raw.faceBlurPx)
  const faceBlurPx = Number.isFinite(faceBlurPxRaw) ? Math.min(9, Math.max(2, Math.round(faceBlurPxRaw))) : 6

  return {
    v: YANO_VIDEO_EFFECTS_VERSION,
    grade,
    soft,
    vignette,
    faceBlur,
    faceBlurPx
  }
}

export function filterStringForVideoEffects(effects) {
  const normalized = normalizeVideoEffects(effects)
  const gradeFilter = VIDEO_GRADES.find((g) => g.id === normalized.grade)?.filter || VIDEO_GRADES[0].filter
  return [gradeFilter, normalized.soft ? SOFT_FILTER : null].filter(Boolean).join(" ")
}
